import React, { forwardRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import uniqueId from "lodash/uniqueId";

/** Material-UI */
import { IconButton, TextField, useMediaQuery } from "@material-ui/core";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";

const AccessibilityTooltip = React.lazy(() => import("../_common/AccessibilityTooltip"));

const useStyles = makeStyles((theme) => ({
    arrowsWrapper: {
        marginLeft: 8,
        display: "flex",
        [theme.breakpoints.down("sm")]: {
            // position: "absolute",
            marginLeft: 0,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
    },
    visuallyhidden: {
        border: 0,
        clip: "rect(0 0 0 0)",
        height: 1,
        margin: -1,
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        width: 1,
    },
}));

const PaginationActions = forwardRef(function PaginationActions(props, ref) {
    const {
        backIconButtonProps,
        count,
        nextIconButtonProps,
        onChangePage = () => {},
        onPageChange = () => {},
        page,
        rowsPerPage,
        ...other
    } = props;

    const classes = useStyles();
    const { t } = useTranslation();

    const isMobile = useMediaQuery("(max-width: 599.95px)");

    const textFieldId = uniqueId("tpa-");

    const [value, setValue] = useState(Number(page + 1));

    useEffect(() => {
        setValue(Number(page + 1));
    }, [page]);

    const handleBackButtonClick = (event) => {
        onChangePage(event, page - 1);
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onChangePage(event, page + 1);
        onPageChange(event, page + 1);
    };

    const handleChangePage = (event) => {
        let value = Number(event.target.value);
        if (value < 1) value = 1;
        if (value > Math.ceil(count / rowsPerPage)) value = Math.ceil(count / rowsPerPage);

        setValue(value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onPageChange(event, value - 1);
    };

    return (
        <div ref={ref} {...other}>
            <div className={classes.arrowsWrapper}>
                <AccessibilityTooltip
                    arrow={false}
                    placement="top"
                    title={t("Poprzednia strona {{page1}}", { page: value - 1 })}
                >
                    <IconButton
                        onClick={handleBackButtonClick}
                        disabled={page === 0}
                        color="inherit"
                        size={isMobile ? "small" : "medium"}
                        {...backIconButtonProps}
                        title=""
                    >
                        <KeyboardArrowLeft fontSize={isMobile ? "small" : "medium"} />
                    </IconButton>
                </AccessibilityTooltip>

                <AccessibilityTooltip
                    arrow={false}
                    placement="top"
                    title={t("Następna strona {{page1}}", { page: value + 1 })}
                >
                    <IconButton
                        onClick={handleNextButtonClick}
                        disabled={count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false}
                        color="inherit"
                        size={isMobile ? "small" : "medium"}
                        {...nextIconButtonProps}
                        title=""
                    >
                        <KeyboardArrowRight fontSize={isMobile ? "small" : "medium"} />
                    </IconButton>
                </AccessibilityTooltip>

                <form
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        fontSize: "clamp(12px, 1vw, 1rem)",
                        margin: "0px 16px",
                    }}
                    onSubmit={handleSubmit}
                >
                    {t("Strona")}
                    {":"}
                    <label htmlFor={textFieldId} className={classes.visuallyhidden}>
                        {t("Strona")}
                    </label>
                    <AccessibilityTooltip arrow={false} placement="top" title={t("Ustaw numer strony")}>
                        <TextField
                            size={"small"}
                            id={textFieldId}
                            label=""
                            value={value}
                            onChange={handleChangePage}
                            variant="outlined"
                            fullWidth={false}
                            inputProps={{
                                // min: 1,
                                size: Math.ceil(count / rowsPerPage)?.toString()?.length,
                                // max: Math.ceil(count / rowsPerPage),
                                style: {
                                    textAlign: "center",
                                    fontSize: "clamp(12px, 1vw, 1rem)",
                                    paddingTop: isMobile ? 5 : 10.5,
                                    paddingBottom: isMobile ? 4 : 10.5,
                                },
                            }}
                            style={{ marginLeft: 8, marginRight: 8 }}
                        />
                    </AccessibilityTooltip>
                    {t("z")}&nbsp;{Math.ceil(count / rowsPerPage)}
                </form>

                {/* <AccessibilityTooltip
                    arrow={false}
                    placement="top"
                    title={t("Następna strona [{{page}}]", { page: value + 1 })}
                >
                    <IconButton
                        onClick={handleNextButtonClick}
                        disabled={count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false}
                        color="inherit"
                        size={isMobile ? "small" : "medium"}
                        {...nextIconButtonProps}
                    >
                        <KeyboardArrowRight fontSize={isMobile ? "small" : "medium"} />
                    </IconButton>
                </AccessibilityTooltip> */}
            </div>
        </div>
    );
});

export default PaginationActions;
